// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sigmet-airmet.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sigmet-airmet/sigmet-airmet.js';

mount([g0]);
